// State of an external training as seen from the anonymous confirmation page.
// Mirrors the backend ExternalConfirmationState enum (serialized as its numeric value).
export enum ExternalConfirmationState {
  Pending = 0,
  Confirmed = 1,
  Declined = 2,
}

// Raw backend response for the anonymous external-training confirmation page.
export interface ExternalTrainingConfirmationViewModel {
  state: ExternalConfirmationState;

  // What was trained
  equipmentName: string | null;
  additionalEquipment: string[];
  learnerName: string | null;
  trainingDate: string;

  // The external tutor's own registered details, to verify before confirming
  tutorName: string | null;
  tutorCompanyName: string | null;
  tutorPhoneNumber: string | null;

  // The company that registered the training
  companyName: string | null;

  // Project — only shown for companies that use projects
  showProject: boolean;
  projectName: string | null;
}
